<template>
  <v-card flat class="px-8 py-4">
    <v-app-bar fixed flat color="background">
      <v-row justify="space-between" align="center">
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
        <v-btn
          v-if="selectedOrders.length"
          outlined
          color="primary"
          @click="acceptOrders"
          class="ml-12"
        >
          {{ $t("Accept orders") }}
        </v-btn>
        <v-checkbox
          class="mt-5 mx-5"
          v-model="acceptOrdersAuto"
          :label="$t('Accept orders automatically on arrival')"
        />
      </v-row>
    </v-app-bar>
    <v-content class="mt-3">
      <v-row justify="center">
        <v-card flat :width="$vuetify.breakpoint.mdAndUp ? '70vw' : '100vw'">
          <v-list>
            <v-hover
              v-for="order in pendingOrders"
              :key="order.id"
              v-slot:default="{ hover }"
              close-delay="50"
            >
              <v-row align="center">
                <v-expand-transition>
                  <v-col cols="1">
                    <v-checkbox
                      transition="slide-x-transition"
                      v-model="selectedOrders"
                      :value="order.id"
                      v-if="hover || selectedOrders.length > 0"
                    />
                  </v-col>
                </v-expand-transition>
                <v-col cols="11">
                  <Order
                    :unclickable="true"
                    @orderClicked="toggleSelectedOrder"
                    :order="order"
                    class="my-4"
                  />
                </v-col>
              </v-row>
            </v-hover>
          </v-list>
        </v-card>
      </v-row>
    </v-content>
  </v-card>
</template>

<script>
import Order from "@/views/dashboard/components/orders/Order";
import { OrderProductStatus } from "@/model/order";

export default {
  components: { Order },

  data() {
    return {
      acceptOrdersAuto: !!this.$store.getters.restaurant.acceptOrdersAuto,
      selectedOrders: []
    };
  },

  computed: {
    pendingOrders() {
      return this.$store.getters.orders.filter(order =>
        order.products.some(
          product => product.status === OrderProductStatus.pending
        )
      );
    }
  },

  watch: {
    acceptOrdersAuto() {
      let restaurant = this.$store.getters.restaurant;
      restaurant.acceptOrdersAuto = this.acceptOrdersAuto;
      restaurant.save();
    }
  },

  methods: {
    toggleSelectedOrder(order) {
      if (this.selectedOrders.some(id => id === order.id)) {
        this.selectedOrders = [
          ...this.selectedOrders.filter(id => id !== order.id)
        ];
      } else {
        this.selectedOrders.push(order.id);
      }
    },

    close() {
      this.$emit("close");
    },

    acceptOrders() {
      this.selectedOrders.forEach(orderId => {
        let order = this.pendingOrders.find(order => order.id === orderId);
        order.updateProductsStatus(
          OrderProductStatus.pending,
          OrderProductStatus.preparing
        );
      });
      this.selectedOrders = [];
    }
  }
};
</script>
